import { render, staticRenderFns } from "./shouhou-steps.vue?vue&type=template&id=4f7daded&scoped=true"
import script from "./shouhou-steps.vue?vue&type=script&lang=js"
export * from "./shouhou-steps.vue?vue&type=script&lang=js"
import style0 from "./shouhou-steps.vue?vue&type=style&index=0&id=4f7daded&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7daded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7daded')) {
      api.createRecord('4f7daded', component.options)
    } else {
      api.reload('4f7daded', component.options)
    }
    module.hot.accept("./shouhou-steps.vue?vue&type=template&id=4f7daded&scoped=true", function () {
      api.rerender('4f7daded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shouhou-steps.vue"
export default component.exports